import axiosApi from '../../axios/axios-api'

const state = {
  salaActual: JSON.parse(localStorage.getItem('salaActual')) ?? {},
  salasNoAdministrativas: [],
  salaActualAdministrativa: JSON.parse(localStorage.getItem('salaActualAdministrativa')) ?? {},
  salasAdministrativas: [],
  // para monitor
  tipo: {},
  estilo: {},
  contentType: 'video',
  media: {},
  selectedMedia: '',
  tipos: [
    {
      id: 1,
      name: 'Recepción'
    },
    {
      id: 2,
      name: 'Consultorios'
    }
  ],
  estilos: [
    {
      id: 1,
      name: 'Solo llamadas',
      type: 'LlamadasSimple'
    },
    {
      id: 2,
      name: 'Llamadas + contenido',
      type: 'LlamadasPlaceHolder'
    }
  ],
  // para recepción
  puestoActual: JSON.parse(localStorage.getItem('puestoActual')) ?? {},
  puestos: [],
  logo: localStorage.getItem('logo') ?? '',
  ParametrosGeneralesAmb: {
    imprimeTicketTotem: true
  },
  terminales: [],
  terminalActual: JSON.parse(localStorage.getItem('terminalActual')) ?? {}
}
const getters = {
  getTipo: (state) => () => {
    var tipo = localStorage.getItem('tipo')
    return JSON.parse(tipo)
  },
  getEstilo: (state) => () => {
    var estilo = localStorage.getItem('estilo')
    return JSON.parse(estilo)
  },
  getSalaActual: (state) => () => {
    var salaActual = localStorage.getItem('salaActual')
    return JSON.parse(salaActual)
  },
  getSalaActualAdministrativa: (state) => () => {
    var salaActualAdministrativa = localStorage.getItem('salaActualAdministrativa')
    return JSON.parse(salaActualAdministrativa)
  },
  getPuesto: (state) => () => {
    var puestoActual = localStorage.getItem('puestoActual')
    return JSON.parse(puestoActual)
  },
  getSelectedMedia: (state) => () => {
    var selectedMedia = localStorage.getItem('selectedMedia')
    return selectedMedia
  },
  getLogo: (state) => () => {
    var logo = localStorage.getItem('logo')
    return logo
  },
  getMedia: (state) => {
    return state.media
  },
  getParametrosGeneralesAmb: (state) => {
    return state.ParametrosGeneralesAmb
  },
  getTerminalActual: (state) => () => {
    var terminalActual = localStorage.getItem('terminalActual')
    return JSON.parse(terminalActual)
  }
}
const mutations = {
  setSala: (state, payload) => {
    localStorage.setItem('salaActual', JSON.stringify(payload))
    state.salaActual = payload
  },
  setSalasNoAdministrativas: (state, payload) => {
    state.salasNoAdministrativas = payload
  },
  setSalaAdministrativa: (state, payload) => {
    localStorage.setItem('salaActualAdministrativa', JSON.stringify(payload))
    state.salaActualAdministrativa = payload
  },
  setSalasAdministrativas: (state, payload) => {
    state.salasAdministrativas = payload
  },
  // para monitor
  setTipo: (state, payload) => {
    localStorage.setItem('tipo', JSON.stringify(payload))
    state.tipo = payload
  },
  setEstilo: (state, payload) => {
    localStorage.setItem('estilo', JSON.stringify(payload))
    state.estilo = payload
  },
  // para recepción
  setPuesto: (state, payload) => {
    localStorage.setItem('puestoActual', JSON.stringify(payload))
    state.puestoActual = payload
  },
  setPuestos: (state, payload) => {
    state.puestos = payload
  },
  setMedia: (state, payload) => {
    state.media = payload
  },
  setSelectedMedia: (state, payload) => {
    localStorage.setItem('selectedMedia', payload)
    state.selectedMedia = payload
  },
  setLogo: (state, payload) => {
    localStorage.setItem('logo', payload)
    state.logo = payload
  },
  setParametrosGeneralesAmb: (state, payload) => {
    state.ParametrosGeneralesAmb = payload
  },
  setTerminal: (state, payload) => {
    localStorage.setItem('terminalActual', JSON.stringify(payload))
    state.terminalActual = payload
  },
  setTerminales: (state, payload) => {
    state.terminales = payload
  }
}
const actions = {
  setSala: ({ commit }, payload) => {
    commit('setSala', payload)
  },
  setSalaAdministrativa: ({ commit }, payload) => {
    commit('setSalaAdministrativa', payload)
  },
  fetchSalas: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get('Taxonomy/Salas?esAdministrativa=3').then(response => {
        var responseData = response.data
        var salasNoAdmin = responseData.data // Incluye todas las salas (no administrativas + administrativas)
        var salasAdmin = responseData.data.filter(x => {
          if (x.esAdministrativa) return x
        })
        commit('setSalasNoAdministrativas', salasNoAdmin)
        commit('setSalasAdministrativas', salasAdmin)
        resolve()
      })
    })
  },
  fetchMedia: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get('Llamadas/Media').then(response => {
        var responseData = response.data
        var media = responseData.data
        commit('setMedia', media)
        commit('setLogo', media.logo ?? '')
        resolve()
      })
    })
  },
  setPuesto: ({ commit }, payload) => {
    commit('setPuesto', payload)
  },
  fetchPuestos: ({ commit }, salaId) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Taxonomy/Salas/${salaId}/Puestos`).then(response => {
        var responseData = response.data
        var puestos = responseData.data
        commit('setPuestos', puestos)
        resolve()
      })
    })
  },
  fetchServices: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Taxonomy/Salas/${state.salaActual.salaId}/Servicios`).then(response => {
        var responseData = response.data
        var services = responseData.data
        resolve(services)
      })
    })
  },
  fetchParametrosGeneralesAmb: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get('autorecepcion/ambulatorio').then(response => {
        var responseData = response.data
        var ambulatorio = responseData.data
        commit('setParametrosGeneralesAmb', ambulatorio)
        resolve(ambulatorio)
      })
    })
  },
  setTerminal: ({ commit }, payload) => {
    commit('setTerminal', payload)
  },
  fetchTerminales: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get('autorecepcion/terminales?isDisabled=true').then(response => {
        var responseData = response.data
        var terminales = responseData.data
        commit('setTerminales', terminales)
        resolve(terminales)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
